export const ADD_PRODUTO = 'ADD_PRODUTO'
export const LIMPAR_CARRINHO = 'LIMPAR_CARRINHO'
export const EXCLUIR_PRODUTO = 'EXCLUIR_PRODUTO'
export const ATUALIZA_QTD_PRODUTO ='ATUALIZA_QTD_PRODUTO'